globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Emailing = appCustomerSpace.Modals.Emailing || {};

appCustomerSpace.Modals.Emailing.ImproveText = (function(superClass) {

  utils.extend(ImproveText, superClass);

  function ImproveText() {
    return ImproveText.__super__.constructor.apply(this, arguments);
  }

  $.extend(ImproveText.prototype, {
    init: function() {
      appCustomerSpace.LimitlessPlugins.initPlugins(this.$html);
      this._edito = String(this.$html.data("edito")) === "true";
      this._initResultEditorDisabled();
      this._bindToggle();
      this._bindGenerate();
      this._bindBriefInput();
      this._bindAutoHeight();
      this._bindSubmit();
      this._refreshKindUI();
      this._refreshGenerateButtonState();

      return ImproveText.__super__.init.apply(this, arguments);
    },

    _currentKind: function() {
      var $active = this.$html.find(".js-mode-tabs li.active .js-mode-toggle").first();
      return $active.data("kind") || "from_scratch";
    },

    _setKind: function(kind) {
      this.$html.find(".js-mode-tabs li").removeClass("active");
      this.$html.find('.js-mode-toggle[data-kind="' + kind + '"]').closest("li").addClass("active");
      this._refreshKindUI();
      this._refreshGenerateButtonState();
    },

    _refreshKindUI: function() {
      var kind = this._currentKind();
      this.$html.find(".js-existing-text-link").toggle(kind === "improve");
    },

    _bindToggle: function() {
      var self = this;
      this.$html.on("click", ".js-mode-toggle", function() {
        self._setKind($(this).data("kind"));
      });
    },

    _bindBriefInput: function() {
      var self = this;
      this.$html.on("input", ".js-brief-text", function() {
        self._refreshGenerateButtonState();
      });
    },

    _bindAutoHeight: function() {
      this.$html.on("input", ".js-auto-height", function() {
        this.style.height = "auto";
        this.style.height = this.scrollHeight + "px";
      });
    },

    _refreshGenerateButtonState: function() {
      var kind = this._currentKind();
      var $btn = this.$html.find(".js-improve-generate-btn");
      if (kind === "improve") {
        var hasExisting = String(this.$html.find('input[name="base_text"]').val() || "").length > 0
                          || String(this.$html.find(".js-show-existing-text").data("content") || "").length > 0;
        $btn.prop("disabled", !hasExisting);
      } else {
        $btn.prop("disabled", false);
      }
    },

    _baseText: function() {
      var kind = this._currentKind();
      if (kind !== "improve") {
        return "";
      }
      var hidden = this.$html.find('input[name="base_text"]').val();
      if (hidden && hidden.length > 0) {
        return hidden;
      }
      return this.$html.find(".js-show-existing-text").data("content") || "";
    },

    _bindGenerate: function() {
      var self = this;
      this.$html.on("click", ".js-improve-generate-btn", function(event) {
        event.preventDefault();
        self._generate();
      });
    },

    _generate: function() {
      var self = this;
      var url = this.$html.data("improve-url");
      var sectionKey = this.$html.data("section-uniq-key");
      var kind = this._currentKind();
      var brief = this.$html.find(".js-brief-text").val();
      var baseText = this._baseText();

      this.$html.find(".js-improve-generate-btn").prop("disabled", true);
      this.$html.find(".js-improve-result-wrapper").addClass("cursor-not-allowed");
      this.$html.find(".js-improve-apply-btn").hide();
      appCustomerSpace.Loader().start({
        $container: this.$html.find(".js-improve-result-editor"),
        options: {
          text: "Jacques rédige…",
          icon_size: "3x",
          style: { backdrop: { background: "rgba(239, 245, 254, 0.7)" } }
        }
      });

      $.ajax({
        url: url,
        method: "POST",
        data: {
          section_uniq_key: sectionKey,
          mode: kind,
          brief: brief,
          base_text: baseText
        },
        success: function(data) {
          if (data.response == 1 && data.html) {
            self._handleGenerationSuccess(data.html);
          } else {
            self._handleGenerationFailure((data.errors || []).join(", "));
          }
        },
        error: function() {
          self._handleGenerationFailure("Erreur lors de la génération.");
        }
      });
    },

    _resultEditorId: function() {
      var $textarea = this.$html.find(".js-improve-result-input");
      var id = $textarea.attr("id");
      if (!id) {
        id = "improve-result-" + Math.floor(Math.random() * 1e9);
        $textarea.attr("id", id);
      }
      return id;
    },

    _initResultEditorDisabled: function() {
      var $textarea = this.$html.find(".js-improve-result-input");
      var id = this._resultEditorId();
      if (typeof CKEDITOR === "undefined") return;
      if (!CKEDITOR.instances[id]) {
        var options = {
          customConfig: $textarea.data("config"),
          readOnly: true,
          height: 80
        };
        var palette = $textarea.data("palette");
        if (palette) {
          options.colorButton_colors = palette;
        }
        CKEDITOR.replace(id, options);
      }
    },

    _expandResultEditor: function() {
      var id = this.$html.find(".js-improve-result-input").attr("id");
      if (id && typeof CKEDITOR !== "undefined" && CKEDITOR.instances[id]) {
        CKEDITOR.instances[id].resize("100%", 240);
      }
    },

    _setResultHtml: function(html) {
      var id = this._resultEditorId();
      var editor = CKEDITOR.instances[id];
      if (editor) {
        editor.setReadOnly(false);
        editor.setData(html);
      } else {
        this.$html.find(".js-improve-result-input").val(html);
      }
    },

    _getResultHtml: function() {
      var id = this.$html.find(".js-improve-result-input").attr("id");
      if (id && typeof CKEDITOR !== "undefined" && CKEDITOR.instances[id]) {
        return CKEDITOR.instances[id].getData();
      }
      return this.$html.find(".js-improve-result-input").val();
    },

    _handleGenerationSuccess: function(html) {
      appCustomerSpace.Loader().stop({ $container: this.$html.find(".js-improve-result-editor") });
      this.$html.find(".js-improve-result-wrapper").removeClass("cursor-not-allowed");
      this.$html.find(".js-improve-apply-btn").show();
      this.$html.find(".js-improve-disclaimer").show();
      this._setResultHtml(html);
      this._expandResultEditor();
      this.$html.find(".js-improve-generate-btn")
        .removeClass("btn-primary").addClass("btn-default")
        .prop("disabled", false);
    },

    _handleGenerationFailure: function(message) {
      appCustomerSpace.Loader().stop({ $container: this.$html.find(".js-improve-result-editor") });
      this.$html.find(".js-improve-result-wrapper").removeClass("cursor-not-allowed");
      this.$html.find(".js-improve-generate-btn").prop("disabled", false);
      new PNotify({ icon: "icon-cross2", title: message || "Erreur lors de la génération.", type: "error" });
    },

    _bindSubmit: function() {
      var self = this;
      this.$html.find("form").on("submit", function() {
        self.$html.find('input[name="html"]').val(self._getResultHtml());
      });
    },

    callbackSuccess: function(data) {
      if (data.response == 1 && data.section_uniq_key && data.html) {
        var $sectionTextarea = $('[data-section-uniq-key="' + data.section_uniq_key + '"] textarea[data-plugin="CKEditor"]').filter(function() {
          return $(this).attr("name") && $(this).attr("name").indexOf("text_element") > -1;
        }).first();
        var sectionEditorId = $sectionTextarea.attr("id");
        if (sectionEditorId && typeof CKEDITOR !== "undefined" && CKEDITOR.instances[sectionEditorId]) {
          CKEDITOR.instances[sectionEditorId].setData(data.html);
        } else if ($sectionTextarea.length) {
          $sectionTextarea.val(data.html).trigger("change").trigger("input");
        }
        var title = this._edito ? "Édito mis à jour" : "Texte mis à jour";
        new PNotify({ icon: "icon-checkmark3", title: title, type: "success" });
      } else {
        new PNotify({ icon: "icon-cross2", title: "Erreur lors de la mise à jour.", type: "error" });
      }
      return ImproveText.__super__.callbackSuccess.apply(this, arguments);
    },

    close: function() {
      var id = this.$html.find(".js-improve-result-input").attr("id");
      if (id && typeof CKEDITOR !== "undefined" && CKEDITOR.instances[id]) {
        CKEDITOR.instances[id].destroy(true);
      }
      return ImproveText.__super__.close.apply(this, arguments);
    }
  });

  return ImproveText;

})(appCustomerSpace.Modal);
